/**
 * @typedef {Object} P2PQuote
 * @property {"binance"|"gate"} exchange
 * @property {"BRL"|"BOB"} fiat
 * @property {"USDT"} asset
 * @property {"BUY"|"SELL"} side
 * @property {number} best
 * @property {number} median
 * @property {number} avg
 * @property {number} samples
 * @property {string} fetchedAt
 * @property {boolean} [experimental]
 * @property {any} [raw] - Dados originais (deve permanecer undefined em produção).
 */

export const ALLOWED_FIATS = ["BRL", "BOB"];
export const ALLOWED_SIDES = ["BUY", "SELL"];
export const DEFAULT_P2P_LIMIT = 10;
